import React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { useDispatch, useSelector } from "react-redux";
import { closeAccessDenied } from "../../../slices/accessDeniedSlice";
import ErrorImage from "../../../assets/maskgroup.png";
import { Button } from "@progress/kendo-react-buttons";

export default function AccessDenied() {
  const dispatch = useDispatch();
  const { status, message } = useSelector((state) => state.accessDenied);

  return (
    <Dialog>
      <div
        className="d-flex flex-column justify-content-around px-5 py-4 align-items-center"
        style={{ width: "400px", height: "250px" }}>
        <img src={ErrorImage} alt="Access Denied" />
        <p className="text-center">{`Access Denied, ${message}`}</p>
        <Button
          style={{ width: "103px" }}
          className="common-btn border-0"
          onClick={() => dispatch(closeAccessDenied())}>
          Close
        </Button>
      </div>
    </Dialog>
  );
}
